// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RoomCallPreviewVideo__container-df221a {
  position: relative;
  display: flex;
  flex: 1;
  background-color: var(--addition-100);
  border-radius: 16px;
  width: 100%;
  max-width: 468px;
  min-height: 331px;
  overflow: hidden;
  align-items: center;
}

.RoomCallPreviewVideo__container-df221a::after {
  content: "";
  display: block;
  padding-top: 56.25%;
}

.RoomCallPreviewVideo__meta-group-c69b99 {
  position: absolute;
  bottom: 6px;
  inset-inline-start: 6px;
  z-index: 1;
  background-color: var(--addition-110_70);
  border-radius: 13px;
  padding: 0 8px;
  display: flex;
  overflow: hidden;
  flex: 0 1 auto;
  align-items: center;
  height: 26px;
}

.RoomCallPreviewVideo__meta-group-c69b99:last-child {
  margin-inline-end: 0;
}

.RoomCallPreviewVideo__name-af20a7 {
  display: flex;
  align-items: center;
  flex: 1;
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-inline-end: 6px;
  font: var(--font-subtitle-3);
  color: var(--addition-50);
}

.RoomCallPreviewVideo__name-af20a7:last-child {
  margin-inline-end: 0;
}

.RoomCallPreviewVideo__muted-b1cae6 {
  flex: 0 0 auto;
  fill: var(--addition-50);
}

.RoomCallPreviewVideo__speaker-indicator-bd6b86 {
  position: absolute;
  inset-inline-start: 50%;
  transform: translate(-50%, 0%);
  bottom: 70px;
  margin: 0;
}

.RoomCallPreviewVideo__content-dc0d61 {
  position: absolute;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.RoomCallPreviewVideo__avatar-d35c1e {
  position: absolute;
  top: 50%;
  inset-inline-start: 50%;
  transform: translate(-50%, -50%);
}

@media (min-width: 1440px) {
  .RoomCallPreviewVideo__container-df221a {
    width: 100%;
    max-height: 596px;
    max-width: 792px;
  }
}
@media (max-width: 1024px) {
  .RoomCallPreviewVideo__container-df221a {
    width: 100%;
    min-height: 331px;
    max-height: 460px;
    max-width: 660px;
  }
}
@media (max-width: 768px) {
  .RoomCallPreviewVideo__container-df221a {
    min-height: auto;
  }
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/components/RoomCallPreviewVideo/RoomCallPreviewVideo.styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,aAAA;EACA,OAAA;EACA,qCAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,cAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,UAAA;EACA,wCAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,OAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,4BAAA;EACA,yBAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,cAAA;EACA,wBAAA;AACF;;AAEA;EACE,kBAAA;EACA,uBAAA;EACA,8BAAA;EACA,YAAA;EACA,SAAA;AACF;;AACA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;AAEF;;AACA;EACE,kBAAA;EACA,QAAA;EACA,uBAAA;EACA,gCAAA;AAEF;;AACA;EACE;IACE,WAAA;IACA,iBAAA;IACA,gBAAA;EAEF;AACF;AACA;EACE;IACE,WAAA;IACA,iBAAA;IACA,iBAAA;IACA,gBAAA;EACF;AACF;AAEA;EACE;IACE,gBAAA;EAAF;AACF","sourcesContent":[".container {\n  position: relative;\n  display: flex;\n  flex: 1;\n  background-color: var(--addition-100);\n  border-radius: 16px;\n  width: 100%;\n  max-width: 468px;\n  min-height: 331px;\n  overflow: hidden;\n  align-items: center;\n}\n\n.container::after {\n  content: '';\n  display: block;\n  padding-top: 56.25%;\n}\n\n.meta-group {\n  position: absolute;\n  bottom: 6px;\n  inset-inline-start: 6px;\n  z-index: 1;\n  background-color: var(--addition-110_70);\n  border-radius: 13px;\n  padding: 0 8px;\n  display: flex;\n  overflow: hidden;\n  flex: 0 1 auto;\n  align-items: center;\n  height: 26px;\n}\n\n.meta-group:last-child {\n  margin-inline-end: 0;\n}\n\n.name {\n  display: flex;\n  align-items: center;\n  flex: 1;\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  margin-inline-end: 6px;\n  font: var(--font-subtitle-3);\n  color: var(--addition-50);\n}\n\n.name:last-child {\n  margin-inline-end: 0;\n}\n\n.muted {\n  flex: 0 0 auto;\n  fill: var(--addition-50);\n}\n\n.speaker-indicator {\n  position: absolute;\n  inset-inline-start: 50%;\n  transform: translate(-50%, 0%);\n  bottom: 70px;\n  margin: 0;\n}\n.content {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.avatar {\n  position: absolute;\n  top: 50%;\n  inset-inline-start: 50%;\n  transform: translate(-50%, -50%);\n}\n\n@media (min-width: 1440px) {\n  .container {\n    width: 100%;\n    max-height: 596px;\n    max-width: 792px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .container {\n    width: 100%;\n    min-height: 331px;\n    max-height: 460px;\n    max-width: 660px;\n  }\n}\n\n@media (max-width: 768px) {\n  .container {\n    min-height: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `RoomCallPreviewVideo__container-df221a`,
	"meta-group": `RoomCallPreviewVideo__meta-group-c69b99`,
	"metaGroup": `RoomCallPreviewVideo__meta-group-c69b99`,
	"name": `RoomCallPreviewVideo__name-af20a7`,
	"muted": `RoomCallPreviewVideo__muted-b1cae6`,
	"speaker-indicator": `RoomCallPreviewVideo__speaker-indicator-bd6b86`,
	"speakerIndicator": `RoomCallPreviewVideo__speaker-indicator-bd6b86`,
	"content": `RoomCallPreviewVideo__content-dc0d61`,
	"avatar": `RoomCallPreviewVideo__avatar-d35c1e`
};
module.exports = ___CSS_LOADER_EXPORT___;
